import { createStore } from 'vuex';

export const useStore = () => createStore();
